import React from "react";
import { useLanguage } from "../hooks/languageService";

const invalidCommand = {
    "pt-BR": `Comando inválido`,
    "en-US": `Invalid command`,
    "es-ES": "Comando inválido",
  };

export function listCategoryItems(
  textToSpeech: any,
  currentCategoryRef: string | undefined,
  currentItemsString: string | undefined,
  language: string
): void {
  const categoryItens = {
    "pt-BR": `Dentro da seção ${currentCategoryRef} temos as seguintes
                opções: ${currentItemsString}. Para ouvir mais detalhes sobre um item,
                ou acrescentá-lo ao seu pedido, diga qual a sua escolha, após o bipe.
                Se quiser ouvir novamente, diga REPITA. Para retornar ao menu inicial,
                diga menu principal.`,
    "en-US": `Within the ${currentCategoryRef} section, we have the following 
              options: ${currentItemsString}. To hear more details about an item 
              or add it to your order, please state your choice after the beep. 
              If you'd like to hear it again, say REPEAT. To return to the main menu, 
              say main menu.`,
    "es-ES": "MENÚ",
  };
  // retorna a lista de itens dentro de uma categoria
  textToSpeech(categoryItens[language as keyof typeof categoryItens]);
}

export function handleDescription(textToSpeech: any, language: string) {
  const description = {
    "pt-BR": `Para adicionar este item ao seu pedido, diga ADICIONAR, após o 
                bipe. Para revisar suas escolhas, diga PEDIDOS. Para ouvir novamente, diga
                Descrição. Para retornar ao menu inicial, diga menu principal`,
    "en-US": `To add this item to your order, say add after the beep. 
              To review your choices, say ORDER. To hear it again, 
              say DESCRIPTION. To return to the main menu, say main menu.`,
    "es-ES": "MENÚ",
  };
  // retorna a descrição do item
  textToSpeech(description[language as keyof typeof description]); 
}

export function handleOrder(textToSpeech: any, itemName: string, language: string) {
  const order = {
    "pt-BR": `${itemName} adicionado aos pedidos. Para ouvir novamente as
                opções diga repita. Para revisar os pedidos diga pedidos.
                Ou diga menu principal para retornar ao menu principal.`,
    "en-US": `${itemName} has been added to your order. To hear the options again, say repeat. 
              To review your order, say order. Or say main menu to return to the main menu.`,
    "es-ES": "MENÚ",
  };
  
  // retorna confirmação do item adicionado ao pedido
  textToSpeech(order[language as keyof typeof order]);
}

export function handleItemOptions(textToSpeech: any, language: string) {
  const itemOptions = {
    "pt-BR": `Para ouvir mais detalhes sobre este item, diga DESCRIÇÃO,
                após o bipe. Para adicionar o item ao seu pedido diga ADICIONAR.
                Para ouvir novamente as opções diga REPITA.`,
    "en-US": `To hear more details about this item, say DESCRIPTION after the beep.
             To add the item to your order, say add. To hear the options again, say REPEAT.`,
    "es-ES": "MENÚ",
  };
  // retorna as opções do item escolhido
    textToSpeech(itemOptions[language as keyof typeof itemOptions]);
}

export function handleInvalidCommand(
  textToSpeech: any,
  setTranscription: any,
  setPlayed: any,
  currentCategoryRef: string | undefined,
  currentItemsString: string | undefined,
  language: string
) {
  textToSpeech(invalidCommand[language as keyof typeof invalidCommand], () => {
    setTranscription("");
    setPlayed(false);
    listCategoryItems(textToSpeech, currentCategoryRef, currentItemsString, language);
  });
}

export function handleInvalidItemCommand(
  textToSpeech: any,
  setTranscription: any,
  setPlayed: any,
  language: string
) {
  textToSpeech(invalidCommand[language as keyof typeof invalidCommand], () => {
    setTranscription("");
    setPlayed(false);
    handleItemOptions(textToSpeech, language);
  });
}
